function authSessionIsEnabled() {
  if (!process.env.NEXT_PUBLIC_AUTH_FEATURE_FLAG) return false;

  return process.env.NEXT_PUBLIC_AUTH_FEATURE_FLAG === 'true';
}

export const AUTH_SESSION_FEATURE_IS_ENABLED = authSessionIsEnabled();
